/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type GaugeCsat_answersReport = {|
  +csat: ?number;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GaugeCsat_answersReport",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "csat",
      "storageKey": null
    }
  ],
  "type": "AnswersReport"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/GaugeCsat/__generated__/GaugeCsat_answersReport.graphql.js